/* eslint-disable no-console */
const consoleArt = () => {
  console.log(
    "\n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#70bfdf10",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00ffffff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00ffffff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#ff0000ff",
    "background-color:#ff0000ff",
    "background-color:#ff0000ff",
    "background-color:#ff0000ff",
    "background-color:#ff0000ff",
    "background-color:#ff0000ff",
    "background-color:#ff0000ff",
    "background-color:#ff0000ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#ff0000ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00ffffff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#ff0000ff",
    "background-color:#ff0000ff",
    "background-color:#ff0000ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#ff0000ff",
    "background-color:#ff0000ff",
    "background-color:#ff0000ff",
    "background-color:#333333ff",
    "background-color:#ff0000ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00ffffff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#ff0000ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#ff0000ff",
    "background-color:#ff0000ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00ffffff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#ff0000ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00ffffff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#ff0000ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#ff0000ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#ff0000ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#ff0000ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00ffffff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00ffffff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00ffffff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#ff0000ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#ff0000ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00ffffff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#ff0000ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#ff0000ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00ffffff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#ff0000ff",
    "background-color:#ff0000ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#00ffffff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#ff0000ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#ff0000ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#ff0000ff",
    "background-color:#ff0000ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#ff0000ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#ff0000ff",
    "background-color:#ff0000ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#ff0000ff",
    "background-color:#ff0000ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#ff0000ff",
    "background-color:#ff0000ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#ff0000ff",
    "background-color:#ff0000ff",
    "background-color:#ff0000ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#ff0000ff",
    "background-color:#ff0000ff",
    "background-color:#ff0000ff",
    "background-color:#ff0000ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#ff0000ff",
    "background-color:#ff0000ff",
    "background-color:#ff0000ff",
    "background-color:#ff0000ff",
    "background-color:#ff0000ff",
    "background-color:#ff0000ff",
    "background-color:#ff0000ff",
    "background-color:#ff0000ff",
    "background-color:#ff0000ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000"
  );

  console.log(
    "\n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  %c  \n%c T E C H N O L O G I E S",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#30303010",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "background-color:#00000000",
    "background-color:#333333ff",
    "background-color:#333333ff",
    "color: #333333ff; font-style: italic; font-size: 32px"
  );

  console.log(
    '%cimport %cXR %cfrom %cSCORTEX%c;\n\n%cif %c(%c_interested %c== %ctrue%c) {\n  %ccall%c(%c"+49 5745 9109000"%c);\n}\n%celse %c{\n  %cgetInfo%c(%c"https://scortex.de"%c);\n}',
    "color: #ff7b72;",
    "color: inherit",
    "color: #ff7b72",
    "color: #ffa657",
    "color: inherit",
    "color: #ff7b72",
    "color: inherit",
    "color: #ffa657",
    "color: inherit",
    "color: #79c0ff",
    "color: inherit",
    "color: #ffa657",
    "color: inherit",
    "color: #a5d6ff",
    "color: inherit",
    "color: #ff7b72",
    "color: inherit",
    "color: #ffa657",
    "color: inherit",
    "color: #a5d6ff",
    "color: inherit"
  );
};

export default consoleArt;
